module.exports = __webpack_public_path__ + "img/shnatMitsva.0bfa8b50.png";